import React from "react";

// @ts-ignore
import { v4 as uuidv4 } from "uuid";

import {
  defaultTestplanData,
  ITestplanViewData,
} from "../../models/testplan/TestplanViewData";
import testplanActions from "../../flux/actions/TestplanActions";
import testplanListStore from "../../flux/stores/testplan/ListStore";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";

import * as CONSTANTS from "../../utilities/Constants";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import loadingActions from "../../flux/actions/LoadingActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { Icon, Spinner } from "@abb/abb-common-ux-react";
import { InputType } from "../../models/shared/IEnumTypes";
import triggerNotifications from "../../utilities/TriggerNotifications";
import testPlanEnableStore from "../../flux/stores/testplan/EnableStore";
import testPlanDisableStore from "../../flux/stores/testplan/DisableStore";
import History from "../../utilities/History";
import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";
import testplanDeleteStore from "../../flux/stores/testplan/DeleteStore";
import { TestplanFormData } from "../../models/testplan/TestplanFormData";
import { NOTIFICATION_TIMEOUT } from "../../utilities/Constants";

interface IViewAllState {
  list: ITestplanViewData[];
  searchValue: { key: String; value: String; type: String; sort: boolean }[];
  sortValue: string;
  sortName: string;
  sortOrder: string;
  selected: string[];
  configDelete: number;
}

export default class ViewAll extends React.Component<{}, IViewAllState> {
  _mount: boolean;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listData: any;
  private _reloadFirst = true;

  private _messages: string[];
  private _activeItem: ITestplanViewData = defaultTestplanData;
  constructor(props: {}) {
    super(props);

    this._mount = false;

    this.state = {
      list: [],
      sortValue: CONSTANTS.LABEL_CREATEDON,
      sortName: CONSTANTS.SORT_CREATEDON,
      sortOrder: CONSTANTS.SORT_DESC_ORDER,
      searchValue: [
        { key: "check", value: "", type: InputType.BLANK, sort: false },
        { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
        {
          key: "InstrumentDetails",
          value: "",
          type: InputType.SEARCHBAR,
          sort: false,
        },
        { key: "Grade", value: "", type: InputType.SEARCHBAR, sort: false },
        { key: "CreatedOn", value: "", type: InputType.BLANK, sort: true },
        { key: "State", value: "", type: InputType.DROPDOWN, sort: false },
        { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
      ],
      selected: [],
      configDelete: 0,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_TESTPLAN,
        action: "View All",
        icon: "abb/view",
        goBackUrl: "",
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    testplanActions
      .getAll(
        true,
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then((response) => {
        this.setState({ list: this._listData });
      });

    testplanListStore.on("change", (state) => {
      if (this._mount) {
        this._listData = [];
        if (
          state.testplanDataList.currentPage ===
            state.testplanDataList.totalPages ||
          state.testplanDataList.totalRecords === 0
        ) {
          this._hasMore = false; // it will show message
        } else {
          this._hasMore = true; // it will show spinner
        }
        this._listData = state.testplanDataList.result;
      }
    });

    testPlanEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.messages;
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this._page = 1;
          testplanActions
            .getAll(
              true,
              this._page,
              CONSTANTS.PAGE_SIZE,
              this.state.sortName,
              this.state.sortOrder,
              ""
            )
            .then(() => {
              loadingActions.setLoading(false);
              this.setState({ list: this._listData });
            })
            .catch(() => loadingActions.setLoading(false));
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });
    testPlanDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.messages;
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this._page = 1;
          testplanActions
            .getAll(
              true,
              this._page,
              CONSTANTS.PAGE_SIZE,
              this.state.sortName,
              this.state.sortOrder,
              ""
            )
            .then(() => {
              loadingActions.setLoading(false);
              this.setState({ list: this._listData });
            })
            .catch(() => loadingActions.setLoading(false));
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    testplanByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._activeItem = state.testplanData;
      }
    });
    testplanDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        this._messages = state.messages;
        this.setState({ configDelete: this.state.configDelete + 1 });
        setTimeout(() => {
          this._page = 1;
          testplanActions
            .getAll(
              true,
              this._page,
              CONSTANTS.PAGE_SIZE,
              this.state.sortName,
              this.state.sortOrder,
              ""
            )
            .then(() => {
              loadingActions.setLoading(false);
              this.setState({ list: this._listData });
            })
            .catch(() => loadingActions.setLoading(false));
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });
  }

  public clearFilter = () => {
    const searchValues = [
      { key: "check", value: "", type: InputType.BLANK, sort: false },
      { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
      {
        key: "InstrumentDetails",
        value: "",
        type: InputType.SEARCHBAR,
        sort: false,
      },
      { key: "Grade", value: "", type: InputType.SEARCHBAR, sort: false },
      { key: "CreatedOn", value: "", type: InputType.BLANK, sort: true },
      { key: "State", value: "", type: InputType.DROPDOWN, sort: false },
      { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
    ];
    this.setState(
      {
        sortValue: CONSTANTS.LABEL_CREATEDON,
        sortName: CONSTANTS.SORT_CREATEDON,
        sortOrder: CONSTANTS.SORT_DESC_ORDER,
        searchValue: searchValues,
      },
      () => {
        testplanActions
          .getAll(
            true,
            this._page,
            CONSTANTS.PAGE_SIZE,
            CONSTANTS.SORT_CREATEDON,
            CONSTANTS.SORT_ORDER,
            ""
          )
          .then((response) => {
            this.setState({ list: this._listData });
          });
      }
    );
  };

  private onEditCick = (data: any) => {
    if (data && data.length) {
      testplanActions
        .getById(data[0].id)
        .then(() => {
          const receivedData = this._activeItem;

          const editData = new TestplanFormData(
            true,
            uuidv4(),
            receivedData.id,
            receivedData.name,
            receivedData.description,
            receivedData.codeId,
            receivedData.instruments,
            receivedData.keyedIns,
            receivedData.isPDC,
            receivedData.sourceId
          );
          History.push(CONSTANTS.TESTPLAN_CREATE_URL, editData);
        })
        .catch((error: any) =>
          triggerNotifications.errors(error.message, error.data)
        );
    }
  };

  private onDeleteClick = (data: any) => {
    const testplanIds: any = [];
    data.forEach((d : any) => {
      testplanIds.push(d.id);          
    });

    loadingActions.setLoading(true);
    testplanActions
      .deleteMultiple(testplanIds, uuidv4())
      .then(() => {
        loadingActions.setLoading(false);

        setTimeout(() => {
          triggerNotifications.success(this._messages).then();
        }, NOTIFICATION_TIMEOUT);
      })
      .catch((error) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onSearch = (name: any, value: any) => {
    const items: any = [];
    this.state.searchValue.forEach((item) => {
      if (item.key === name) {
        items.push({
          key: item.key,
          value: value,
          sort: item.sort,
          type: item.type,
        });
      } else {
        items.push(item);
      }
    });

    let strConcat = "";
    items.forEach((item: any) => {
      if (item.value.length) {
        strConcat = strConcat + `${item.key}:${item.value}&`;
      }
    });

    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      this._page = 1;
      testplanActions
        .getAll(
          true,
          1,
          CONSTANTS.PAGE_SIZE,
          this.state.sortName,
          this.state.sortOrder,
          strConcat
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState({ list: this._listData, searchValue: items });
        });
    } else {
      this.setState({ searchValue: items });
    }
  };

  public onSortHandler = (name: any, value: any, order: any) => {
    this.setState(
      {
        sortValue: value,
        sortName: name,
        sortOrder: order,
      },
      () => {
        loadingActions.setLoading(true);
        let strConcat = "";
        this.state.searchValue.forEach((item: any) => {
          if (item.value.length) {
            strConcat = strConcat + `${item.key}:${item.value}&`;
          }
        });
        this._page = 1;
        testplanActions
          .getAll(
            true,
            this._page,
            CONSTANTS.PAGE_SIZE,
            this.state.sortName,
            this.state.sortOrder,
            strConcat
          )
          .then(() => {
            loadingActions.setLoading(false);
            this.setState({ list: this._listData });
          })
          .catch(() => loadingActions.setLoading(false));
      }
    );
  };

  public fetchMore = () => {
    loadingActions.setLoading(true);
    let strConcat = "";
    this.state.searchValue.forEach((item: any) => {
      if (item.value.length) {
        strConcat = strConcat + `${item.key}:${item.value}&`;
      }
    });
    this._page = this._page + 1;
    testplanActions
      .getAll(
        true,
        this._page,
        CONSTANTS.PAGE_SIZE,
        this.state.sortName,
        this.state.sortOrder,
        strConcat
      )
      .then(() => {
        loadingActions.setLoading(false);
        const data = [...this.state.list, ...this._listData];
        this.setState({ list: data });
      })
      .catch(() => loadingActions.setLoading(false));
  };

  private onEnableClick = (data: any) => {
    let modifiedData = data[data.length - 1];
    const Id = modifiedData.id;
    testplanActions
      .enable(Id, uuidv4())
      .then(() => {
        setTimeout(() => {
          triggerNotifications.success(this._messages).then();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      })
      .catch((error: { message: string[]; data: any }) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onDisableClick = (data: any) => {
    let modifiedData = data[data.length - 1];
    const Id = modifiedData.id;
    testplanActions
      .disable(Id, uuidv4())
      .then(() => {
        triggerNotifications.success(this._messages).then();
        setTimeout(() => {});
      })
      .catch((error: { message: string[]; data: any }) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  goBack = () => {
    History.push(CONSTANTS.TESTPLAN_INDEX_URL);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="app-container mt-4">
              <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 viewall-page">
                <div>
                  <Icon
                    name="abb/caret-left"
                    sizeClass="large"
                    style={{ cursor: "pointer" }}
                    onClick={this.goBack}
                  />
                </div>
                <div className="viewall-page-title">
                  <span
                    className="title font-weight-bold mt-2 ml-1 "
                    style={{ verticalAlign: "super" }}
                  >
                    {t(CONSTANTS.ALL_TESTPLANS)}
                  </span>
                </div>
              </div>
              <div className="ml-1">
                <InfiniteScroll
                  dataLength={this.state.list.length} //This is important field to render the next data
                  next={this.fetchMore}
                  hasMore={this._hasMore}
                  loader={
                    <div>
                      <h6
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Spinner color="blue" sizeClass="medium" />
                      </h6>
                      <div></div>
                    </div>
                  }
                  scrollThreshold={0.6}
                  scrollableTarget="scrollableDiv"
                >
                  <AbbTableComponent
                  authKey={CONSTANTS.AUTHKEY_TEST_PLAN}
                    columns={[
                      {
                        dataField: "checkbox",
                        type: InputType.BLANK,
                        text: "",
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_TESTPLAN),
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "instrumentDetailsName",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.LABEL_INSTRUMENTS_LIST),
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "grade.name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_GRADE),
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "formatedDate",
                        type: InputType.BLANK,
                        text: t(CONSTANTS.LABEL_CREATEDON),
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "state",
                        type: InputType.DROPDOWN,
                        text: t(CONSTANTS.LABEL_STATE),
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "filterIcon",
                        type: InputType.BLANK,
                        text: "",
                        editable: false,
                        style: { width: "5%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "5%", textAlign: "left" };
                        },
                      },
                    ]}
                    list={this.state.list}
                    searchValue={this.state.searchValue}
                    onSearchHandler={this.onSearch}
                    sortOrder={this.state.sortOrder}
                    sortValue={this.state.sortValue}
                    onSortHandler={this.onSortHandler}
                    clearFilter={this.clearFilter}
                    select={false}
                    isFixedColumn={false}
                    isEditable={false}
                    delete={false}
                    moduleName={t(CONSTANTS.ALL_PRODUCTS)}
                    redirectBaseUrl={CONSTANTS.MODULE_TESTPLAN}
                    deleteModuleName={t(CONSTANTS.TESTPLANS)}
                    isEditAction={true}
                    isDeleteAction={true}
                    DeleteAction={this.onDeleteClick}
                    editHandler={this.onEditCick}
                    configDelete={this.state.configDelete}
                    isDisableAction={true}
                    isEnableAction={true}
                    EnableAction={this.onEnableClick}
                    DisableAction={this.onDisableClick}
                    view={true}
                    viewAllPage={true}
                    isTitle={
                      <div className="float-left ml-1">
                        <div className="box-circle">
                          <p className="box-circle-text"> 1 </p>
                        </div>
                        <div className="ml-4">
                          <p className="sidebar-main-title font-weight-bold ml-2">
                            {t(CONSTANTS.MODULE_TESTPLAN)}
                          </p>
                        </div>
                      </div>
                    }
                  />
                </InfiniteScroll>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
